import { MouseEvent, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { View } from '@shared/components/View';
import styles from './AnchoredSheet.module.css';
import { AnchoredSheetProps } from './props';
import { useTitleBar } from './useTitleBar';

export function AnchoredSheet({
  children,
  onClose,
  title,
  renderTitleBar,
  anchorName,
  align = 'right',
  className,
  backdropClassName,
  style,
  testID,
}: AnchoredSheetProps) {
  const titleBar = useTitleBar(title, renderTitleBar);
  const alignLeft = align === 'left';

  const onClickOverlay = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      onClose();
    },
    [onClose],
  );

  return ReactDOM.createPortal(
    <>
      <View
        aria-hidden="true"
        onClick={onClickOverlay}
        className={[styles.anchoredSheetBackdrop, backdropClassName]}
        testID="bottom-sheet-overlay"
      />
      <View
        role="dialog"
        aria-modal="true"
        className={[styles.anchoredSheet, alignLeft && styles.alignLeft, className]}
        style={{ positionAnchor: anchorName, ...style }}
        testID={testID}
      >
        {titleBar}
        {children}
      </View>
    </>,
    document.body,
  );
}
